import * as FwDatas from "../FwDatas.ts";
import * as i18n from "../i18n.ts";
import * as Html from "../util/Html.ts";

Html.registerWidget('widget/user-picker',{initDom})

const updaters: Record<string, (obj: HTMLElement, toAll: boolean, names: string[]) => void> = {
  none: function(){},
  updateTextIm: function (obj, toAll, names){
    let text = i18n.get("labels.recipients")+ " ";
    if(toAll){
      text += i18n.get("new_message.all");
    }else{
      text += names.join(', ');
    }
    const paragraphs = obj.querySelectorAll('p');
    const lastP = paragraphs[paragraphs.length - 1] as HTMLElement;
    if (lastP) lastP.textContent = text;
  },
  updateTextTask: function(obj, toAll, names){
    let text: string;
    if(toAll){
      text = i18n.get("task_details.assigntoall");
    }else if(names.length){
      text = i18n.get("task_details.assignto",names.join(', '));
    }else{
      text = i18n.get("task_details.assigntonobody");
    }
    const label = obj.querySelector('.label') as HTMLElement;
    if (label) label.textContent = text;
  },
  updateTextTaskList: function(obj, toAll, names){
    const text = i18n.get("catsystem.sharedwith")+names.map(n=>'<span class="color-branded">'+Html.escape(n)+'</span>').join(', ');
    const firstP = obj.querySelector('p') as HTMLElement;
    if (firstP) firstP.innerHTML = text;
  },
  updateTextBudget: function(obj, toAll, names){

  },
  updateTextTimetable: function(obj, toAll, names){
    const text = '<b>'+i18n.get("timetable.label.sharedwithusers")+'</b> '+Html.escape(names.join(', '));
    const firstP = obj.querySelector('p') as HTMLElement;
    if (firstP) firstP.innerHTML = text;
  },
  updateTextEvent: function (obj, toAll, names){
    let text = i18n.get("new_event.attendees")+": ";
    if(toAll){
      text += i18n.get("new_message.all");
    }else if(names.length===0){
      text += i18n.get("labels.none");
    }else{
      text += names.join(', ');
    }
    const firstP = obj.querySelector('p') as HTMLElement;
    if (firstP) firstP.textContent = text;
  }
}
function initDom(obj: HTMLElement){
  const textUpdater = obj.getAttribute('data-textupdater') || 'none'; //method to update the first p
  const initialValue = (obj.getAttribute('data-value') || "").replace(/,$/,'');
  const acceptEmpty = (obj.getAttribute('data-acceptempty') || "true") === "true";
  const useEmpty = obj.getAttribute('data-useempty') === 'true';
  const imgs = obj.querySelectorAll('img');
  const firstImg = imgs[0];
  const familyNode = firstImg?.getAttribute('data-accountId') ? null : firstImg;
  const select = obj.querySelector('select');
  const ownToAllInput = obj.querySelector('input');
  const toAllInput = ownToAllInput||obj.closest('form').sharedToAll;
  const accountNode = obj.querySelectorAll<HTMLElement>('img[data-accountId]');
  const allAccountIds = Array.from(accountNode).map((node: Element) => {
    return (node as HTMLElement).getAttribute('data-accountId')!;
  });
  let accountIds = initialValue === "" ? [] : (initialValue === "all" ? allAccountIds : initialValue.split(','));

  obj.addEventListener('clear', function(){
    accountIds = toAllInput.value==='true'?allAccountIds:[];
    refresh();
  })  
    
  function isAll(){
    return accountIds.length>=allAccountIds.length;
  }
  
  function refresh(updateToAll = true){
    if(isAll()){
      familyNode?.classList.add('selected');
      accountNode.forEach(node => (node as HTMLElement).classList.add('selected'));
    }else{
      familyNode?.classList.remove('selected');
      accountNode.forEach((node) => {
        const accountId = node.getAttribute('data-accountId');
        if(accountId && accountIds.indexOf(accountId) > -1){
          node.classList.add('selected');
        }else{
          node.classList.remove('selected');
        }
      });
    }
    if(accountIds.length > 0){
      let options = "";
      for(let i=0; i<accountIds.length; i++){
        options += '<option value="'+accountIds[i]+'" selected></option>'
      }
      select.innerHTML = options;
    }else if(useEmpty){
      select.innerHTML = '<option value="$empty" selected></option>';
    }else{
      select.innerHTML = '';
    }
    if(updateToAll){
      toAllInput.value = String(isAll());
    }

    const names = accountIds.map(accountId => {
      const img = obj.querySelector(`img[data-accountId='${accountId}']`) as HTMLElement;
      return img?.getAttribute('title') || '';
    }).filter(name => name);

    updaters[textUpdater](obj, isAll(), names);
    select.dispatchEvent(new Event('change'));

    const event = new CustomEvent('pickedaccounts', {
      detail: {
        accounts: accountIds.map(accountId => FwDatas.getProfile(accountId)),
        isAll: isAll()
      },
      bubbles: true
    });
    obj.dispatchEvent(event);
  }
  
  setTimeout(()=>refresh(!!ownToAllInput), 50);

  accountNode.forEach((node) => {
    node.addEventListener('click', function(){
      const accountId = this.getAttribute('data-accountId');
      if (!accountId) return;

      if(isAll()){
        accountIds = [accountId];
      }else if(accountIds.indexOf(accountId) === -1){
        accountIds.push(accountId);
      }else if(accountIds.length > 1 || acceptEmpty){
        accountIds.splice(accountIds.indexOf(accountId), 1);
      }
      refresh();
    });
  });

  if (familyNode) {
    familyNode.addEventListener('click', function(){
      if(isAll()){
        if(acceptEmpty){
          accountIds = [];
        }
      }else{
        accountIds = [...allAccountIds];
      }
      refresh();
    });
  }
}